<mat-dialog-content>
	<p [innerHTML]="text"></p>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-button color="grey" [mat-dialog-close]="false">ANNULEREN</button>
	<button *ngIf="action_type === 'confirm'" mat-button color="primary" [mat-dialog-close]="true">BEVESTIGEN</button>
	<button *ngIf="action_type === 'delete'" mat-button color="accent" [mat-dialog-close]="true">VERWIJDEREN</button>
</mat-dialog-actions>
